import { createSlice } from "@reduxjs/toolkit";
import { TUnauthorizedState } from "../../routeWithState/IRouteWithState";
interface unAuthorizedState {
    state: string;
};
/* newFlow****** */
// changed UnauthorizedContainer to login
const initialState = {
    state: 'login'
};

export const unAuthorizedStateLocalSlice = createSlice({
    name: 'unAuthorizedState',
    initialState,
    reducers: {
        setUnAuthorizedState: (state: unAuthorizedState, action: any) => {
            state.state = action.payload.state;
        },

    }
});
export const { setUnAuthorizedState }: any = unAuthorizedStateLocalSlice.actions;

export default unAuthorizedStateLocalSlice.reducer;